import {HasId, Timestamped} from '../shared/interfaces';

export type TRole = 'admin' | 'av' | 'publisher' | 'worshiper' | 'worship_leader' | 'moderator' | 'email_sender' | 'camper';

export class Role {
    static ADMIN: TRole = 'admin';
    static AUDIO_VIDEO: TRole = 'av';
    static PUBLISHER: TRole = 'publisher';
    static WORSHIPER: TRole = 'worshiper';
    static WORSHIP_LEADER: TRole = 'worship_leader';
    static MODERATOR: TRole = 'moderator';
    static EMAIL_SENDER: TRole = 'email_sender';
    static CAMPER: TRole = 'camper';

    static LABEL = {
        admin: 'Admin',
        av: 'Audio-video',
        publisher: 'Tartalomkezelő',
        worshiper: 'Dicsőítő',
        worship_leader: 'Dicsőítés vezető',
        moderator: 'Moderátor',
        email_sender: 'Email küldő',
        camper: 'Táboros',
    };

    private _value: TRole;

    static forValue(role: string): Role {
        return new Role(role);
    }

    static isValid(role: string): boolean {
        return [
            Role.ADMIN,
            Role.AUDIO_VIDEO,
            Role.PUBLISHER,
            Role.WORSHIP_LEADER,
            Role.WORSHIPER,
            Role.MODERATOR,
            Role.EMAIL_SENDER,
            Role.CAMPER,
        ].includes(<TRole>role);
    }

    constructor(role: TRole | string) {
        if (!Role.isValid(role)) {
            throw new Error(role + ' is not a valid role!');
        }
        this._value = <TRole>role;
    }

    equals(role: Role | TRole | string): boolean {
        return this._value === '' + role;
    }

    toJSON() {
        return this._value;
    }

    toString() {
        return this._value;
    }
}

export interface IRole extends HasId, Timestamped {
    role: string;
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/auth/role.ts